/**
 * Buybox v3 — loaded only when the "RU - Buybox v3" block is present.
 *
 * Owns the three purchase options and the add-to-cart payload. Everything is
 * driven by data attributes rendered in Liquid, so there are no observers or
 * polling here (both are what made the v2 buybox choke in the theme editor).
 */
(function () {
  'use strict';

  var STICKY_TYPE_BY_OPTION = {
    quarterly: 'pack_subscription',
    monthly: 'subscription',
    onetime: 'one_time',
  };

  var OPTION_BY_STICKY_TYPE = {
    pack_subscription: 'quarterly',
    subscription: 'monthly',
    one_time: 'onetime',
    bundle: 'onetime',
    bundle_2: 'onetime',
  };

  function getForm(root) {
    return document.getElementById(root.dataset.formId);
  }

  function getSelection(root) {
    var card = root.querySelector('[data-ru-bb3-option].is-selected');
    if (!card) return null;

    var selection = {
      key: card.dataset.ruBb3Option,
      card: card,
      variantId: card.dataset.variantId,
      sellingPlan: card.dataset.sellingPlan || '',
      lockQty: card.dataset.lockQty === 'true',
      quantity: Number(card.dataset.quantity || 1) || 1,
      total: card.dataset.totalFormatted || '',
      compare: card.dataset.compareFormatted || '',
    };

    if (selection.key === 'onetime') {
      var pack = card.querySelector('[data-ru-bb3-pack].is-selected');
      if (pack) {
        selection.quantity = Number(pack.dataset.quantity || 1) || 1;
        selection.total = pack.dataset.totalFormatted || selection.total;
        selection.compare = pack.dataset.compareFormatted || '';
      }
    }

    return selection;
  }

  function buildPriceMarkup(selection) {
    if (!selection || !selection.total) return '';
    var markup = '';
    if (selection.compare) {
      markup += '<div class="sls-original-price"><s>' + selection.compare + '</s></div>';
    }
    markup += '<div class="sls-price">' + selection.total + '</div>';
    return markup;
  }

  function stickyShowsComparePrice() {
    var section = document.querySelector('#product-section');
    return !section || section.dataset.stickyShowComparePrice !== 'false';
  }

  function isSubscriptionSelection(selection) {
    return selection && (selection.key === 'monthly' || selection.key === 'quarterly');
  }

  function getBasePriceFormatted(root) {
    return (root && root.dataset.basePriceFormatted) || '';
  }

  function getOneTimeSelectCompare(select) {
    if (!select) return '';
    var oneTime = Array.prototype.slice.call(select.options).filter(function (option) {
      return option.dataset.purchaseType === 'one_time';
    })[0];
    return (oneTime && (oneTime.dataset.compare || oneTime.dataset.price)) || '';
  }

  function buildStickyPriceMarkup(selection, compareFallback, root) {
    if (!selection || !selection.total) return '';
    var markup = '<div class="sls-price">' + selection.total + '</div>';
    var compare =
      selection.compare || compareFallback || getBasePriceFormatted(root) || '';
    if (compare && selection.total && compare.replace(/\s/g, '') === selection.total.replace(/\s/g, '')) {
      compare = '';
    }
    if (stickyShowsComparePrice() && isSubscriptionSelection(selection) && compare) {
      markup += '<div class="sls-original-price"><s>' + compare + '</s></div>';
    }
    return markup;
  }

  function syncForm(root, selection) {
    var form = getForm(root);
    if (!form || !selection) return;

    var variantInput = form.querySelector('input[name="id"], input.product-variant-id');
    if (variantInput && selection.variantId) variantInput.value = selection.variantId;

    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput) {
      planInput.value = selection.sellingPlan || '';
      planInput.disabled = !selection.sellingPlan;
    }
  }

  function paintStickyPrices(markup, savingsLabel) {
    document
      .querySelectorAll('#product-section .sticky-bar-buttons-v2 .selected-option-price')
      .forEach(function (priceEl) {
        priceEl.innerHTML = markup;
        priceEl.hidden = !markup;
      });

    document.querySelectorAll('#product-section [data-sticky-bar-savings]').forEach(function (savings) {
      savings.textContent = savingsLabel || '';
      savings.hidden = !savingsLabel;
    });
  }

  function syncCtaPrices(root, selection) {
    var showInlinePrice = root.dataset.showCtaPrice === 'true';
    var inlineMarkup = showInlinePrice ? buildPriceMarkup(selection) : '';
    document
      .querySelectorAll('#product-section .purchase-form-inline-cta .selected-option-price')
      .forEach(function (priceEl) {
        priceEl.innerHTML = inlineMarkup;
        priceEl.hidden = !inlineMarkup;
      });
  }

  function syncStickySelect(root, selection) {
    if (!selection) return;
    var select = document.querySelector('#product-section [data-sticky-bar-plan-select]');
    var match = null;
    var compareFallback = '';
    var savingsLabel = '';

    if (select) {
      var wanted = STICKY_TYPE_BY_OPTION[selection.key];
      var options = Array.prototype.slice.call(select.options);
      match = options.filter(function (option) {
        return option.dataset.purchaseType === wanted;
      })[0];

      if (match && select.selectedIndex !== match.index) {
        select.selectedIndex = match.index;
      }

      // Keep select option price aligned with buybox; preserve select/one-time compare
      // as fallback when the buybox card UI does not expose a compare-at.
      compareFallback =
        (match && match.dataset.compare) || getOneTimeSelectCompare(select) || '';
      if (match) {
        if (selection.total) match.dataset.price = selection.total;
        if (selection.compare) {
          match.dataset.compare = selection.compare;
          compareFallback = selection.compare;
        } else if (!match.dataset.compare && compareFallback) {
          match.dataset.compare = compareFallback;
        }
      }
      savingsLabel = match && match.dataset.savings ? match.dataset.savings : '';
    }

    var stickyMarkup = buildStickyPriceMarkup(selection, compareFallback, root);
    paintStickyPrices(stickyMarkup, savingsLabel);
  }

  function syncOneTimeHeaderPrice(root) {
    var card = root.querySelector('[data-ru-bb3-option="onetime"]');
    if (!card) return;
    var priceEl = card.querySelector('[data-ru-bb3-onetime-price]');
    var suffixEl = card.querySelector('[data-ru-bb3-onetime-suffix]');
    var totalEl = card.querySelector('[data-ru-bb3-onetime-total]');
    var pack = card.querySelector('[data-ru-bb3-pack].is-selected');
    if (!priceEl) return;

    if (!pack) {
      card.classList.remove('is-pack-3');
      return;
    }

    var qty = Number(pack.dataset.quantity || 1) || 1;
    card.classList.toggle('is-pack-3', qty > 1);
    if (qty > 1) {
      priceEl.textContent = pack.dataset.unitFormatted || pack.dataset.totalFormatted || priceEl.textContent;
      if (suffixEl) {
        suffixEl.textContent = pack.dataset.unitSuffix || '';
        suffixEl.hidden = !pack.dataset.unitSuffix;
      }
      if (totalEl) {
        totalEl.textContent = pack.dataset.headerTotal || '';
        totalEl.hidden = !pack.dataset.headerTotal;
      }
      return;
    }

    priceEl.textContent = pack.dataset.totalFormatted || pack.dataset.unitFormatted || priceEl.textContent;
    if (suffixEl) {
      suffixEl.textContent = '';
      suffixEl.hidden = true;
    }
    if (totalEl) {
      totalEl.textContent = '';
      totalEl.hidden = true;
    }
  }

  function apply(root) {
    syncOneTimeHeaderPrice(root);
    var selection = getSelection(root);
    if (!selection) return;
    syncForm(root, selection);
    syncStickySelect(root, selection);
    syncCtaPrices(root, selection);
  }

  function selectOption(root, key) {
    root.querySelectorAll('[data-ru-bb3-option]').forEach(function (card) {
      var isActive = card.dataset.ruBb3Option === key;
      card.classList.toggle('is-selected', isActive);
      card.setAttribute('aria-checked', isActive ? 'true' : 'false');
      var input = card.querySelector('.ru-bb3-card__radio input');
      if (input) input.checked = isActive;
    });
    apply(root);
  }

  function selectPack(root, packEl) {
    var card = packEl.closest('[data-ru-bb3-option]');
    if (!card) return;
    card.querySelectorAll('[data-ru-bb3-pack]').forEach(function (pack) {
      var isActive = pack === packEl;
      pack.classList.toggle('is-selected', isActive);
      pack.setAttribute('aria-checked', isActive ? 'true' : 'false');
      var input = pack.querySelector('.ru-bb3-pack__radio input');
      if (input) input.checked = isActive;
    });
    selectOption(root, card.dataset.ruBb3Option);
  }

  function getAjaxCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function openCartAfterAdd(root, response, triggerEl) {
    var afterAdd = root.dataset.afterAdd || 'drawer';
    var cart = getAjaxCart();

    if (afterAdd === 'drawer' && cart && response && response.sections) {
      cart.classList.remove('is-empty');
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(triggerEl || document.activeElement);
      }
      cart.renderContents(response);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response });
      }
      return;
    }

    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function addToCart(root, button) {
    var selection = getSelection(root);
    if (!selection || !selection.variantId) return;

    syncForm(root, selection);

    var item = {
      id: Number(selection.variantId),
      quantity: selection.quantity,
    };
    if (selection.sellingPlan) item.selling_plan = Number(selection.sellingPlan);
    if (selection.lockQty) {
      item.properties = { _ru_lock_qty: '1', _ru_pack_subscription: '1' };
    }

    var payload = { items: [item] };
    var cart = getAjaxCart();
    if ((root.dataset.afterAdd || 'drawer') === 'drawer' && cart) {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }
        openCartAfterAdd(root, response, button);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        button.classList.remove('loading');
      });
  }

  function getRoot() {
    return document.querySelector('#product-section [data-ru-bb3]');
  }

  function bindRoot(root) {
    if (root.dataset.ruBb3Bound === 'true') return;
    root.dataset.ruBb3Bound = 'true';

    root.addEventListener('click', function (event) {
      var pack = event.target.closest('[data-ru-bb3-pack]');
      if (pack) {
        selectPack(root, pack);
      } else {
        var card = event.target.closest('[data-ru-bb3-option]');
        if (card) selectOption(root, card.dataset.ruBb3Option);
      }

      // Pointer selection (incl. Shift+click) must not leave a focus ring / double border.
      if (event.detail > 0 && document.activeElement && root.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target.closest('[data-ru-bb3-pack], [data-ru-bb3-option]');
      if (!target) return;
      event.preventDefault();
      if (target.matches('[data-ru-bb3-pack]')) {
        selectPack(root, target);
      } else {
        selectOption(root, target.dataset.ruBb3Option);
      }
    });

    apply(root);
  }

  function bindGlobals() {
    if (window.__ruBuyboxV3Bound) return;
    window.__ruBuyboxV3Bound = true;

    // Capture phase so the v2 buybox handlers and the native form submit never run.
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('[data-main-add-button]');
        if (!button) return;
        var root = getRoot();
        if (!root) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        addToCart(root, button);
      },
      true
    );

    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-sticky-bar-plan-select]');
      if (!select) return;
      var root = getRoot();
      if (!root) return;
      var type = select.options[select.selectedIndex] && select.options[select.selectedIndex].dataset.purchaseType;
      var key = OPTION_BY_STICKY_TYPE[type];
      if (key && root.querySelector('[data-ru-bb3-option="' + key + '"]')) {
        selectOption(root, key);
      }
    });

    document.addEventListener('shopify:section:load', function () {
      var root = getRoot();
      if (root) bindRoot(root);
    });
  }

  function init() {
    var root = getRoot();
    if (!root) return;
    bindGlobals();
    bindRoot(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
